import MagicCircle from '../images/MagicCircle.png';
import Property from '../images/Property.png';
import Weapon1 from '../images/weapon_img1.png';
import Weapon2 from '../images/weapon_img2.png';
import Units1ja from '../images/units_img1_ja.png';
import Units1en from '../images/units_img1_en.png';
import Units2 from '../images/units_img2.png';

export default function Article(props) {

  return (
    <>
      <div className="article">
        <h2>
          {props.lang === 'ja' ? 'Magic Circle NFT' : 'Magic Circle NFT'}
        </h2>
        <div className="flex mt-2">
          <div>
            <img width='300' src={MagicCircle} alt="" />
          </div>
          <div className="ml-2">
            {props.lang === "ja" && (
              <>
                <p>キャラクターを10体購入いただくと"魔法陣NFT"を1つ、15体購入で2つが後日獲得できるようになります。</p>
                <p>魔法陣NFTは、今後Isekai Battleをプレイする上で関わってくるアイテムとなりますので、どのような形で使用されるかについてはお楽しみにしておいてください。</p>
                <p>※5体購入を3回のトランザクションに分けても15体の購入と見なされます。</p>
                <p>※獲得のタイミングはパブリックセール以降となります。</p>
              </>
            )}
            {props.lang === "en" && (
              <>
                <p>The Magic Circle NFT is an NFT that can be obtained later. 1 for those who purchase 10 Characters, 2 for those who purchase 15.</p>
                <p>It will be later used as an in-game item for Isekai Battle, so please look forward to its utility.</p>
                <p>*Splitting a purchase of 15 into three transactions (5 Characters each) will still count as purchasing 15 Characters.</p>
                <p>*The Magic Circle NFT will become available sometime after the public sale.</p>
              </>
            )}
          </div>
        </div>

        <h2>
          {props.lang === 'ja' ? 'セット購入時の1体あたりの価格' : 'Price of one Character when bought as a set.'}
        </h2>
        <table>
          <thead>
            <tr>
              <th>Character</th>
              <th>eth / 1Character</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1</td>
              <td rowSpan={4}>0.055eth + gas fees</td>
            </tr>
            <tr>
              <td>2</td>
            </tr>
            <tr>
              <td>3</td>
            </tr>
            <tr>
              <td>4</td>
            </tr>
            <tr className="price1">
              <td>5</td>
              <td rowSpan={5}>0.054eth + gas fees</td>
            </tr>
            <tr className="price1">
              <td>6</td>
            </tr>
            <tr className="price1">
              <td>7</td>
            </tr>
            <tr className="price1">
              <td>8</td>
            </tr>
            <tr className="price1">
              <td>9</td>
            </tr>
            <tr className="price2">
              <td>10</td>
              <td rowSpan={5}>0.053eth + gas fees</td>
            </tr>
            <tr className="price2">
              <td>11</td>
            </tr>
            <tr className="price2">
              <td>12</td>
            </tr>
            <tr className="price2">
              <td>13</td>
            </tr>
            <tr className="price2">
              <td>14</td>
            </tr>
            <tr className="price3">
              <td>15</td>
              <td>0.05eth + gas fees</td>
            </tr>
          </tbody>
        </table>

        <h2>
          {props.lang === 'ja' ? '武器・防具と攻撃力・防御力について' : 'Weapons/Armor and Attack/Defence Power'}
        </h2>
        <div className="flex mt-2">
          <div>
            <img src={Weapon1} alt="" />
          </div>
          <div className="ml-2">
            {props.lang === "ja" && (
              <>
                <p>武器は5種類、防具は3種類存在し、キャラクターとマッチする武器・防具を装備することで、部隊のステータスがアップします。</p>
                <p>武器・防具はリージョンを「探索」すると入手できます。</p>
              </>
            )}
            {props.lang === "en" && (
              <>
                <p>There are 5 types of Weapons and 3 types of Armor.When they match the Characters’ favorite equipment, the Units will get stat boosts.</p>
                <p>You can find Weapons and Armor by “Exploration”.</p>
              </>
            )}

            <img src={Weapon2} alt="" className='mt-1' />

          </div>
        </div>

        <h2>Units</h2>
        {props.lang === "ja" && (
          <p className="mt-2">キャラクターは「探索部隊」「攻撃部隊」「守備部隊」にそれぞれ最大5体まで配置ができます。</p>
        )}
        {props.lang === "en" && (
          <p className="mt-2">Set up to 5 characters each for “Exploration Unit”, “Attack Unit”, and “Defence Unit”.</p>
        )}
        <div className="mt-2">
          {props.lang === "ja" && (
            <img src={Units1ja} alt="" className='mt-1' />
          )}
          {props.lang === "en" && (
            <img src={Units1en} alt="" className='mt-1' />
          )}
        </div>
        {props.lang === "ja" && (
          <>
            <p className="mt-2">争奪バトルに勝利するとフラグメントを奪うことができます。</p>
            <p>攻撃部隊に多くキャラを配置すると勝率は上がりますが、守備部隊が手薄になりフラグメントが奪われやすくなります。</p>
            <p>そのため、各部隊のバランスが重要になります。</p>
          </>
        )}
        {props.lang === "en" && (
          <>
            <p className="mt-2">You can take Fragments by winning Battles against other players.</p>
            <p>By having more characters in the Attack Unit, your chances of winning will increase, but having less in the Defence Unit means other players have a higher chance to take your Fragments.</p>
            <p>The balance between the Units is crucial.</p>
          </>
        )}
        <div className="mt-2">
          <img src={Units2} alt="" className='mt-3' />
        </div>

        <h2>
          Generation
        </h2>
        <div className="flex mt-2">
          <div>
            <img width='512' src={Property} alt="" />
          </div>
          <div className="ml-2">
            {props.lang === "ja" && (
              <>
                <p>キャラクターNFTのプロパティ部分にGenerationの記載があります。</p>
                <p>Generationは「種」の使用や合成のトークンの消費に関わる部分に影響があります。</p>
                <p>キャラクターのIDが1〜5500までがGeneration 0（Gen0）、5501以降の下一桁が１〜９のIDについてはGeneration 1（Gen1）、5501以降の下一桁が0のIDについてはGeneratiOn 0.5（Gen0.5）となっております。</p>
                <p>Gen0のキャラクターはトークンの消費量を10%軽減する効果があります。Gen0.5はトークンの消費量が5%軽減されます。</p>
              </>
            )}
            {props.lang === "en" && (
              <>
                <p>The Character NFTs have a property of Generation.</p>
                <p>It affects the token consumption for the use and fusion of Seeds.</p>
                <p>Character IDs 1 - 5500 are Generation 0 (Gen0), 5501 and on with the last digit 1- 9 are Generation 1 (Gen1), and 5501 and on with the last digit 0 are Generation 0.5 (Gen0.5).</p>
                <p>Gen0 Characters will cut the token consumption by 10% and Gen0.5 will cut it by 5%.</p>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
